import React from 'react'
import {Helmet} from "react-helmet";
import PaydasCard from '../../paydascard/PaydasCard'
import PageTitle from '../../pagetitle/PageTitle'

export default function Paydaslar()
{
    const title = "OKAF Paydaş Üniversiteler - Samsun Üniversitesi";
    const description = "Samsun Üniversitesi ev sahipliğinde gerçekleşecek olan Orta Karadeniz Kariyer Fuarı (OKAF)'ın paydaş üniversitelerine ulaşmak için tıklayınız!";
    return (
        <>
            <Helmet>
                <title>{title}</title>
                <meta name="description" content={description} />
            </Helmet>
            <PageTitle name="Paydaş Üniversiteler"></PageTitle>
            <PaydasCard />
        </>
    )
}
